module.exports = __webpack_public_path__ + "team.svg?050387deaf02e95edb8fc4d8c0339777";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/team.svg
// module id = 99
// module chunks = 0